module.exports = __webpack_public_path__ + "static/media/dtreecontent.f646845d.PNG";